import { request } from '@/services/http/client';

export interface OssPolicyRecord {
  access_key_id: string;
  access_key_secret: string;
  security_token: string;
  bucket: string;
  dir?: string;
  region?: string;
  mock?: boolean;
}

export interface OssObjectUrlRecord {
  url: string;
}

export const getOssPolicy = async () =>
  request<OssPolicyRecord>({
    url: '/api/v1/public/oss/generate-post-policy',
    method: 'get',
  });

export const getOssObjectUrl = async (url: string) =>
  request<OssObjectUrlRecord>({
    url: '/api/v1/public/oss/get-object-presign-url',
    method: 'get',
    params: {
      url,
    },
  });
